// client/src/screens/ImpersonateGate.jsx
import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Box, CircularProgress, Typography, Button, Stack } from '@mui/material'
import API from '../../services/API'

export default function ImpersonateGate() {
  const navigate = useNavigate()
  const { search } = useLocation()
  const [state, setState] = useState({ loading: true, error: null })

  useEffect(() => {
    const params = new URLSearchParams(search)
    const token = params.get('token')

    if (!token) {
      setState({ loading: false, error: 'Missing impersonation token.' })
      return
    }

    // Important: send credentials so the server can set a session cookie
    // Ensure your API instance is created with { withCredentials: true }
    API.post('/admin/impersonatelogin', { token }, { withCredentials: true })
      .then((res) => {
        if (res.status === 200) {
          window.location.href = '/'
        } else {
          setState({ loading: false, error: 'Impersonation Failed' })
        }
      })
      .catch((e) => {
        let msg = 'Impersonation failed.'
        if (e?.response?.data?.error) msg = e.response.data.error
        setState({ loading: false, error: msg })
      })

    // fetch('/admin/impersonatelogin', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   credentials: 'include',
    //   body: JSON.stringify({ token }),
    // })
    //   .then(async (r) => {
    //     if (r.ok) window.location.href = '/'
    //     else {
    //       const data = await r.json().catch(() => ({}))
    //       throw new Error(data?.message || 'Impersonation failed')
    //     }
    //   })
    //   .catch((e) => {
    //     setState({
    //       loading: false,
    //       error: e.message || 'Impersonation failed.',
    //     })
    //   })
  }, [search, navigate])

  if (state.loading) {
    return (
      <Box
        sx={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Signing you in…
        </Typography>
      </Box>
    )
  }

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6">Impersonation Error</Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 520, textAlign: 'center' }}
        >
          {state.error || 'Something went wrong.'}
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" onClick={() => navigate('/login')}>
            Go to Login
          </Button>
          <Button
            variant="contained"
            onClick={() =>
              (window.location.href = 'https://crmadmin.ambunet.co.uk/')
            }
          >
            Back to CRM
          </Button>
        </Stack>
      </Stack>
    </Box>
  )
}
